import { useEffect, useState } from 'react';

interface WindowSize {
  innerWidth: number;
  innerHeight: number;
}

function getWindowSize(): WindowSize {
  const { innerWidth, innerHeight } = window;
  return { innerWidth, innerHeight };
}

export const useWindowSize = (): WindowSize => {
  const [windowSize, setWindowSize] = useState<WindowSize>(getWindowSize());

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  return windowSize;
};
